import { Payee } from "@wingspanhq/wingspan-api-sdk";

/**
 * Resolves a human display name for a v3 `Payee`.
 *
 * v1 stored granular identity (first/last/preferred name + company legal/DBA)
 * across `user`/`member`/`payerOwnedData` and resolved it via `wsName`
 * (`getPayeeName`). v3 collapses all of that into a single `profile.displayName`,
 * so this is the v3-shape equivalent — kept separate from the still-v1
 * `getPayeeName` (which its many v1 feeders still rely on). Falls back to the
 * company DBA, then email, then id, so the UI never renders an empty string.
 *
 * Semantic drift: the v1 first/last/preferred ladder is lost — v3 exposes a
 * single display string.
 */
export const selectorPayeeDisplayName = (payee: Payee): string =>
  payee.profile?.displayName ||
  payee.profile?.company?.doingBusinessAs ||
  payee.email ||
  payee.id ||
  "";
